module.exports = __webpack_public_path__ + "static/lighter-than-air-sophie-blanchard-the-first-woman-pilot-d2afef6023a4c5b8f8d5593392ed56c9.jpg";